import { MutationQueryFactory } from './MutationQuery.js';
export class DeleteQueryFactory extends MutationQueryFactory {
    constructor(shapeClass, ids) {
        super();
        this.shapeClass = shapeClass;
        this.ids = this.convertNodeReferences(ids);
    }
    getQueryObject() {
        return {
            type: 'delete',
            shape: this.shapeClass.shape,
            ids: this.ids,
        };
    }
}
//# sourceMappingURL=DeleteQuery.js.map